import { styled } from 'styled-components'

import { SegmentCard } from '../Segment/Segment.Styled'

export const StyledContainer = styled(SegmentCard)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
`

export const StyledMoneyBackContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyledMoneyBackImage = styled.img`
  overflow: hidden;
  width: 100%;
  height: 100px;
  object-fit: contain;
`

export const StyledCheckoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

export const StyledCardWrapper = styled.div`
  overflow: hidden;
  width: 35px;
  height: 24px;
  border: 1px solid ${({ theme }) => theme.colors['N Surface/Secondary']};
  border-radius: 4px;
`
